import { Link } from '@/components/ui/link';

import { newsStyles } from '../../styles';

// Define PageReference Component for reusable tag styling
export const PageReference = ({
  text,
  href,
}: {
  text: string;
  href?: string;
}) => {
  const styles = newsStyles();

  return href ? (
    <Link
      to={href}
      className={styles.pageReference({
        className: styles.clickable(),
      })}
    >
      {text}
    </Link>
  ) : (
    <span className={styles.pageReference()}>{text}</span>
  );
};
